// extracted by mini-css-extract-plugin
var _1 = "ProfileLabelsWidgetForm-moduleformFieldsWrapper__p3UKH";
export { _1 as "formFieldsWrapper" }
